import { KULT_0501_INCOMPLETE_VALUE_DIAGNOSTIC_CODES, KULT_0501_METHODOLOGY_DIAGNOSTIC_CODES, } from "../types/reports/kult0501Report";
// Residual branch on purpose: a code the frontend does not know yet must still
// reach the user, and the warning group is the only one that cannot understate it.
export var kult0501DiagnosticGroupOf = function (code) {
    if (KULT_0501_METHODOLOGY_DIAGNOSTIC_CODES.includes(code))
        return "methodology";
    if (KULT_0501_INCOMPLETE_VALUE_DIAGNOSTIC_CODES.includes(code))
        return "incompleteValue";
    return "unclassified";
};
